import { Form, Header, Popup } from "semantic-ui-react";
import PaymentFrequency from "./PaymentFrequency";
import { StringUtils } from "utils";
import PriceField from "./PriceField";
import { Controller, useFormContext } from "react-hook-form";
import { Icon, LabeledInput } from "dyl-components";

const getMonthlyPrice = (frequency, price) => {
    if (isNaN(price)) {
        return "";
    }
    const monthlyPrice = (() => {
        if (frequency === "monthly") {
            return price;
        }
        if (frequency === "quarterly") {
            return price / 3;
        }
        if (frequency === "semi-annually") {
            return price / 6;
        }
        if (frequency === "annually") {
            return price / 12;
        }
        return 0;
    })();
    return Number(monthlyPrice).toFixed(2);
};

const FixedRecurringFields = () => {
    const { control, watch } = useFormContext();
    const maxDiscount = watch("max_discount");
    const isDiscountDisabled = !maxDiscount || Number(maxDiscount) <= 0;

    return ["monthly", "quarterly", "semi-annually", "annually"].map(
        (frequency) => {
            const parentName = `fixed_recurring`;
            const priceFieldName = `price_data.${parentName}_${frequency}_price`;
            const discountFieldName = `price_data.${parentName}_${frequency}_max_discount_cycle`;
            const noExpirationFieldName = `price_data.${parentName}_${frequency}_life_time_discount`;
            return (
                <PaymentFrequency
                    parentName={parentName}
                    frequency={frequency}
                    key={frequency}
                    content={
                        <div>
                            <Header color="primary">
                                {StringUtils.capitalize(frequency)}
                            </Header>
                            <Form.Group>
                                <PriceField
                                    label={"Price Per Item"}
                                    name={priceFieldName}
                                    width={8}
                                />

                                <Controller
                                    control={control}
                                    name={priceFieldName}
                                    render={({ field: { value } }) => (
                                        <Form.Field
                                            control="div"
                                            label="Per Month"
                                            width={3}
                                        >
                                            ${getMonthlyPrice(frequency, value)}
                                        </Form.Field>
                                    )}
                                />

                                <Form.Field width={5}>
                                    <Controller
                                        control={control}
                                        name={discountFieldName}
                                        defaultValue={1}
                                        render={({ field: { value, onChange } }) => (
                                            <LabeledInput
                                                label="Discount Expiration"
                                                prefix="Billing Cycle"
                                                type="number"
                                                value={value}
                                                onChange={onChange}
                                                inputProps={{
                                                    min:1,
                                                }}
                                                required
                                                disabled={isDiscountDisabled}
                                            />
                                        )}
                                    />

                                    <Controller
                                        control={control}
                                        name={noExpirationFieldName}
                                        render={({ field: { value, onChange } }) => (
                                            <div style={{ display: "flex", alignItems: "center", gap: "4px", marginTop: "10px", opacity: isDiscountDisabled ? 0.5 : 1 }}>
                                                <Form.Checkbox
                                                    label="No Expiration"
                                                    checked={!!value}
                                                    disabled={isDiscountDisabled}
                                                    onChange={(_, { checked }) => onChange(checked)}
                                                />
                                                <Popup
                                                    content={"Lifetime discount"}
                                                    inverted
                                                    position="bottom right"
                                                    trigger={<Icon className="fas fa-info-circle" color="primary" />}
                                                    disabled={isDiscountDisabled}
                                                />
                                            </div>
                                        )}
                                    />
                                </Form.Field>
                            </Form.Group>
                        </div>
                    }
                />
            );
        }
    );
};

export default FixedRecurringFields;
